import { Bound } from "lib/@components/binding/Bound"
import { TabledRepeat } from "lib/@components/tabled-repeat/tabled-repeat"
import LoadingScreen from "minimals-template/components/LoadingScreen"
import { useEffect, useMemo } from "react"
import { AddGroupTaskRow } from "./add-group-task-row"
import { Stack, Typography } from "@mui/material"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { If } from "lib/@components/switch"
import { Else } from "lib/@components/else"
import { AddTasksButton } from "../../plugins/add-tasks-button"
import { ExtendedNoResults } from "../extended-no-results"
import { useEnrichedMacroMap } from "authoring/routes/macro/hooks/use-enriched-macro-map"
import { collectMacroTokensFromSchedule } from "authoring/routes/macro/lib/macro-token-utils"
import { Secure } from "lib/authorization/secure"
import { Frag } from "lib/@components/slot/frag"
import { AUTHORING_EDIT_SCHEDULES_DEMAND } from "authoring/lib/constants/authoring-permissions.mjs"
import { ResetTabledRepeat } from "event-definitions"

const tableHeaders = [
    { title: "" },
    { title: "Name" },
    { title: "Duration" },
    { title: "Frequency" },
    { title: "Skillset" },
    { title: "" },
    { title: "" },
    { title: "" },
]

export function AddGroupTasks() {
    const { projectGroup } = useBoundContext()
    const tasks = useMemo(getTasks, [projectGroup?.newTasks])
    const tokenIds = useMemo(collectTaskTokenIds, [tasks])

    useEffect(() => {
        ResetTabledRepeat.raiseOnce()
    }, [tasks])
    const { macroMap, loading: macrosLoading } = useEnrichedMacroMap({ tokenIds })

    if (tasks?.length > 0 && tokenIds.length > 0 && macrosLoading) return <LoadingScreen />

    return (
        <If truthy={tasks?.length > 0}>
            <Stack spacing={2}>
                <Typography sx={{ fontWeight: "medium" }}>Tasks</Typography>
                <Bound macroMap={macroMap}>
                    <TabledRepeat
                        items={tasks}
                        itemPass="task"
                        tableHeaders={tableHeaders}
                        itemComponent={<AddGroupTaskRow />}
                        alternating={false}
                    />
                </Bound>
            </Stack>
            <Else>
                <ExtendedNoResults
                    message="You haven't added any tasks yet"
                    component={
                        <Secure demand={AUTHORING_EDIT_SCHEDULES_DEMAND} fallback={<Frag />}>
                            <AddTasksButton alternativeVariant="outlined" />
                        </Secure>
                    }
                />
            </Else>
        </If>
    )

    function collectTaskTokenIds() {
        if (!tasks?.length) return []
        return [...collectMacroTokensFromSchedule({ tasks })]
    }

    function getTasks() {
        return projectGroup?.newTasks ?? []
    }
}
